import { expandedVSForMobile } from './seoPageTypes'

/**
 * Expan Vehicle Selector in defined page types to solve CLS issues
 * with pages having pre-populated vehicle information
 *
 * @param {Object} selectBoxes `apiDetails.selectBoxes` from Strapi
 * @param {string} pageType Page Type
 * @returns Object
 */
const expandMobile = (selectBoxes, pageType) => {
  if (expandedVSForMobile.includes(pageType)) {
    return selectBoxes.map(x => {
      const selected = x
      selected.isMobile = true

      return selected
    })
  }

  return selectBoxes
}

export default expandMobile
